var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gift_card_assign_task_table_pane" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "300px" },
            attrs: { placeholder: "请输入任务名称", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.search($event)
              },
            },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.search },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { "margin-left": "100px" },
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.addAssignTask },
            },
            [_vm._v("\n      新增发放任务\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "编码", align: "left", width: "200", prop: "fnId" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "卡样",
              align: "center",
              width: "150",
              prop: "coverImage",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-image", {
                      attrs: {
                        src: _vm.imgAccessDomain + scope.row.coverImage,
                        alt: "卡样",
                        width: "100",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "任务名称",
              align: "center",
              width: "200",
              prop: "taskTitle",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "用途/面额",
              align: "center",
              width: "200",
              prop: "faceValue",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.chargeTypeDesc) +
                        " / " +
                        _vm._s(scope.row.cardPrice) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "发放人数",
              align: "center",
              width: "100",
              prop: "assignMemCount",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleShowMembers(scope.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.assignMemCount) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "卡片/人",
              align: "center",
              width: "100",
              prop: "assignQty",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "时间",
              align: "center",
              width: "200",
              prop: "createTimeFormatter",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          创建：" +
                          _vm._s(scope.row.createTimeFormatter) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          发放：" +
                          _vm._s(scope.row.assignTimeFormatter) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "校对状态",
              align: "center",
              width: "120",
              prop: "checkStatusDesc",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.checkStatus === "unchecked"
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("\n          未校对\n        "),
                        ])
                      : scope.row.checkStatus === "checked"
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("\n          校对无误\n        "),
                        ])
                      : scope.row.checkStatus === "rejected"
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("\n          校对未通过\n        "),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "审核状态",
              align: "center",
              width: "120",
              prop: "auditStatusDesc",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.auditStatus === "unassigned"
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("\n          未发放\n        "),
                        ])
                      : scope.row.auditStatus === "executed_assigned"
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("\n          已发放\n        "),
                        ])
                      : scope.row.auditStatus === "rejected"
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("\n          未通过\n        "),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.checkStatus === "unchecked" ||
                    scope.row.checkStatus === "rejected"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handlecheckStatus(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          校对\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.checkStatus === "checked" &&
                    (scope.row.auditStatus === "unassigned" ||
                      scope.row.auditStatus === "rejected")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAuditStatus(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          审核\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.limit,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发放人员",
            visible: _vm.dialogVisible,
            width: "40%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "发放人员：" } },
                _vm._l(_vm.memberList, function (item) {
                  return _c(
                    "el-tag",
                    { key: item.fnId, staticStyle: { "margin-right": "10px" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.userName) +
                          " | " +
                          _vm._s(item.alias) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.type === "check" || _vm.type === "audit"
                ? _c(
                    "el-form-item",
                    [
                      _vm.type === "check"
                        ? _c(
                            "el-button",
                            { on: { click: _vm.handleCheckRejected } },
                            [_vm._v("\n          暂不通过\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type === "audit"
                        ? _c(
                            "el-button",
                            { on: { click: _vm.handleAuditRejected } },
                            [_vm._v("\n          暂不通过\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type === "check"
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleCheckPass },
                            },
                            [_vm._v("\n          校对无误\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type === "audit"
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleAuditPass },
                            },
                            [_vm._v("\n          审核通过\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "view"
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "info" },
                          on: { click: _vm.handleClose },
                        },
                        [_vm._v("关闭")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }